import { render, staticRenderFns } from "./VideoSearch.vue?vue&type=template&id=5283ab1b&scoped=true&"
import script from "./VideoSearch.vue?vue&type=script&lang=js&"
export * from "./VideoSearch.vue?vue&type=script&lang=js&"
import style0 from "./VideoSearch.vue?vue&type=style&index=0&id=5283ab1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5283ab1b",
  null
  
)

export default component.exports